// Resumo das visitas ao site (dados de getSiteVisits: { today, hour, days })
// para o card do Painel Administrativo.
//
// O período atual termina agora: hoje até a hora atual + os dias anteriores
// inteiros. O anterior tem o mesmo formato, deslocado: dias inteiros + o dia
// equivalente a "hoje" cortado na mesma hora — assim "Dia" compara hoje até
// as 14h com ontem até as 14h, e não com o dia inteiro de ontem.

export const SITE_VISIT_PERIODS = {
  day: { label: 'Dia', length: 1, comparison: 'vs ontem' },
  week: { label: 'Semana', length: 7, comparison: 'vs semana anterior' },
  month: { label: 'Mês', length: 30, comparison: 'vs mês anterior' },
};

function shiftDay(date, delta) {
  const d = new Date(`${date}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + delta);
  return d.toISOString().slice(0, 10);
}

function visitsUntilHour(day, hour) {
  return Object.entries(day.hours || {})
    .filter(([h]) => Number(h) <= hour)
    .reduce((sum, [, n]) => sum + (n || 0), 0);
}

// → { visits, uniqueVisitors, changePct (null sem dados do período anterior), comparison }
export function summarizeSiteVisits({ today, hour, days }, period) {
  const { length, comparison } = SITE_VISIT_PERIODS[period];
  const byDate = Object.fromEntries((days || []).map((d) => [d.date, d]));

  let visits = 0;
  let uniqueVisitors = 0;
  for (let i = 0; i < length; i++) {
    const day = byDate[shiftDay(today, -i)];
    if (!day) continue;
    visits += day.visits || 0;
    uniqueVisitors += day.uniqueVisitors || 0;
  }

  let previous = 0;
  for (let i = length; i < 2 * length; i++) {
    const day = byDate[shiftDay(today, -i)];
    if (!day) continue;
    previous += i === length ? visitsUntilHour(day, hour) : day.visits || 0;
  }

  const changePct = previous > 0 ? Math.round(((visits - previous) / previous) * 100) : null;
  return { visits, uniqueVisitors, changePct, comparison };
}
